
namespace TabAurous.ProductDevelopment {
    import fld = SpecSheetItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SpecSheetItemsDialog extends _Ext.ItemEditorDialog<SpecSheetItemsRow> {
        protected getFormKey() { return SpecSheetItemsForm.formKey; }
        protected getLocalTextPrefix() { return SpecSheetItemsRow.localTextPrefix; }

        public form = new SpecSheetItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 300;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            q.hideEditorTab(this.form.LaborDetails);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.Image1);
            q.hideEditorLabel(this.form.Image2);
            q.hideEditorLabel(this.form.Image3);
            q.hideEditorLabel(this.form.Image4);
            q.hideEditorLabel(this.form.Image5);
            q.hideEditorLabel(this.form.Image6);
            q.hideEditorLabel(this.form.Image7);
            q.hideEditorLabel(this.form.Image8);
            q.hideEditorLabel(this.form.Video1);
            q.hideEditorLabel(this.form.Video2);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            // **** On Pieces Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {

                    var lbr = this.form.LaborDetails.getItems();
                    var self = this;
                    lbr.forEach(function (x) {
                        x.Weight = self.form.Weight.value;
                        x.Pieces = self.form.Pieces.value;
                        x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                    });

                    this.form.LaborDetails.setItems(lbr);
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
                    q.showAndEnableField(this.form.CalcOnId);
                    q.showAndEnableField(this.form.CalcUnitId);
                    var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == this.ItemMaster.form.VoucherTypeId.value);

                    switch (this.form.ItemTypeId.value) {
                        case 101:
                            this.form.DepartmentId.value = VoucherDetails.DefaultJewelleryDepartment;
                            break;
                        case 104:
                            this.form.DepartmentId.value = VoucherDetails.DefaultMetalDepartment;
                            break;
                        case 105:
                            this.form.DepartmentId.value = VoucherDetails.DefaultStoneDepartment;
                            break;
                    }
                }
            });

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }

                    this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                }
            });

            this.form.DesignCode.changeSelect2(e => {
                if (this.form.DesignCode.value != null) {
                    try {
                        var criteria: any;
                        var PrdRow: OMS.DesignRow;
                        OMS.DesignService.List({
                            Criteria: Serenity.Criteria.and(criteria, [[OMS.DesignRow.Fields.DesignCode], '=', this.form.DesignCode.value.toUpperCase()])
                        }, response => PrdRow = response.Entities[0], { async: false });

                        if (PrdRow != undefined) {
                            if (PrdRow.DesignId != null || PrdRow.DesignId > 0) {
                                Q.notifyError("Duplicate Design Code " + this.form.DesignCode.value);
                                this.form.DesignCode.value = "";
                                this.form.DesignCode.element.focus();
                                return;
                            }
                        }
                        else {
                            this.form.DesignCode.value = this.form.DesignCode.value.toUpperCase();
                        }
                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                if (this.form.SubCategoryId.value != "")
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);;
                q.showAndEnableField(this.form.CalcOnId);
                q.showAndEnableField(this.form.CalcUnitId);
            });

            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () {
                        self.removeBOM();
                        ItemFieldHelper.PurchaseItemFields(self, self.ItemMaster.form.VoucherTypeId.value);
                    }, function () {
                        self.form.HasBom.value = true;
                    });
                } else
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });

            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as SpecSheetDialog).form.TransDate.value);
                    this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.ProductTypeId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }


            });
            this.form.MF.changeSelect2(e => {
                this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;
            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

        }

        getItem() {
            return this.getSaveEntity();
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        // #endregion
        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as SpecSheetDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.entity.TransDate;
            this.PartyId = parseInt(this.ItemMaster.form.PartyId.value);

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }

            var c = this.form.CalcOnId.value;
            ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

            q.showAndEnableField(this.form.CalcOnId);
            q.showAndEnableField(this.form.CalcUnitId);
            q.hideField(this.form.ProductCode);
            q.hideField(this.form.ProductName);
            this.form.CalcOnId.value = c;
            q.showAndEnableField(this.form.RefNo);
            var fieldEditor: JQuery = this.form.RefNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }
        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = ProductDevelopment.CustomerRequirementSelectGrid;
                var options: _Ext.SelectGridFilters = {

                }

                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Customer Requirement", GridFilters: options
                });

                pickerDialog.onSuccess = (selectedItems: ProductDevelopment.CustomerRequirementItemsRow[]) => {

                    if (selectedItems.length > 0) {
                        this.form.RefNo.value = selectedItems[0].RefNo
                    }
                }
                pickerDialog.dialogOpen();
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var c = this.form.CalcOnId.value;
            return returnvalue;
        }

    }
}